import React, { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from '@reach/router';
import { Layout } from '@cld/widget-demos-common';
import { messages } from '../../i18n';
import { toHome } from '../../router';
import { SettingsTab } from './SettingsTab';
import { EmbedCode } from './sections/codeTab/EmbedCode';
import { ConsoleResponse } from './sections/codeTab/ConsoleResponse';
import { Widget } from './Widget';

export const Main: FC = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const handleOnClose = useCallback(() => navigate(toHome()), [navigate]);

  return (
    <Layout
      title={formatMessage(messages['common.applicationTitle'])}
      onClose={handleOnClose}
      settingsTab={<SettingsTab />}
      codeTabSections={[EmbedCode, ConsoleResponse]}
      widget={<Widget />}
    />
  );
};
